export * from './focus-trap.directive';
export * from './focus-trap.module';
